var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EditIcon,{staticClass:"bc-add-icon",attrs:{"icon":_vm.canAdd ? 'plus-filled' : 'plus',"disabled":!_vm.canAdd},on:{"execute":function($event){return _vm.$emit('execute')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }